/**
 * Created by lu on 2018/4/9.
 */
var nb = require('../../../../nb');
var ImgItemModelType = require('./ImgItem');
var VideoItemModelType = require('./VideoItem');
var ImgItemType = require('../../view/banner/ImgItem');
var VideoItemType = require('../../view/banner/VideoItem');

module.exports = nb.define({
    parent: require('../../../../model/swiper/Swiper'),
    method: {
        init: function () {
            // nb.model.onChange(nb.opts.clientReady,function () {
            nb.model.onChange('initSwiper', function () {
                var swiper = new Swiper('#'+this.get('swiperId'), {
                    speed: 800,
                    loop:true,
                    effect:'fade',
                    autoplay: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    }
                });
            },this);
        },
        getItemType: function (inIndex, inItem) {
            if (inItem.get('videoUrl')) {
                return VideoItemType
            } else {
                return ImgItemType
            }
        },
        getItemModelType: function (inIndex, inItem) {
            if (inItem.videoUrl) {
                return VideoItemModelType
            } else {
                return ImgItemModelType
            }
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/model/banner/Swiper.js
// module id = 524
// module chunks = 6